"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.loadUserEpic = void 0;

var _utils = require("@alycecom/utils");

var _operators = require("rxjs/operators");

var _user = require("./user.actions");

var loadUserEpic = function loadUserEpic(action$, state$, _ref) {
  var apiService = _ref.apiService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _utils.ofType)(_user.loadUserRequest), (0, _operators.mergeMap)(function () {
    return apiService.get("/enterprise/user").pipe((0, _operators.map)(function (response) {
      return (0, _user.loadUserSuccess)(response.user);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _user.loadUserFail
    })));
  }));
};

exports.loadUserEpic = loadUserEpic;
var _default = [loadUserEpic];
exports.default = _default;